export const THEME_NAME_PLAYGROUND = 'playground'
export const THEME_NAME_SWISSTECH = 'swisstech'
export const THEME_NAME_DEVELOPMENT = 'development'

export const themes = {
    playground: THEME_NAME_PLAYGROUND,
    swisstech: THEME_NAME_SWISSTECH,
    development: THEME_NAME_DEVELOPMENT,
}
